export default [
    {path: '/', name: 'Home',component: () => import('@/ecom/views/pages/Home.vue')},
    {path: '/page_builder/live_preview', name: 'LivePreview',component: () => import('@/ecom/views/pages/LivePreview.vue')}
]